import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { ExpenseReportParams, getExpenseReport } from 'config/requests/expenseReport';
import { ExpenseReport } from 'types/embedded/expenseReport';

export function useExpenseReport(filters: Partial<ExpenseReportParams>) {
  const {
    data: expenseReport,
    isLoading,
    isFetching,
    isPending,
  } = useQuery<ExpenseReport>({
    queryKey: [
      Resources.ExpenseReport,
      filters.expenseArticles,
      filters.expenseTypes,
      filters.expenseSubarticles,
      filters.currency,
      filters.dateTo,
      filters.dateFrom,
      filters.referral,
    ],
    queryFn: () => getExpenseReport(filters as ExpenseReportParams),
    enabled: !!Object.values(filters).length,
  });

  return { expenseReport, isLoading, isFetching, isPending };
}
